// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27pa8","newExpiryDate":"styles_newExpiryDate__28Bqu","footer":"styles_footer__1UTZ9"};